import { useGetActiveModelVersionQuery } from 'features/templates/templatesApi';

const parsedTemplateCache = new WeakMap();

export function useGetTemplate(modelId, source = 'local') {
    const { activeModelVersion } = useGetActiveModelVersionQuery(
        { id: modelId, source },
        {
            skip: !modelId,
            selectFromResult: ({ data }) => ({
                activeModelVersion: data,
            }),
        }
    );

    if (!activeModelVersion?.payloadJson) {
        return null;
    }

    let parsed = parsedTemplateCache.get(activeModelVersion);

    if (!parsed) {
        const jsonData = JSON.parse(activeModelVersion.payloadJson);

        parsed = {
            ...jsonData,
            version: activeModelVersion.version,
            templateCategory: activeModelVersion.templateCategory,
        };

        parsedTemplateCache.set(activeModelVersion, parsed);
    }

    return parsed;
}
